module.exports = __webpack_public_path__ + "static/img/rank_background_official.896373d1.png";